// traceability: requirements: [FR-015, FR-017]
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RTL_LANGUAGES } from '@/types/i18n';
import type { SupportedLanguage, TextDirection } from '@/types/i18n';

export function useDirection(): TextDirection {
  const { i18n } = useTranslation();
  const lang = i18n.language as SupportedLanguage;
  const dir: TextDirection = RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [dir, lang]);

  return dir;
}
